var map = {
	"./earring1.webp": 16359,
	"./earring2.webp": 19479,
	"./frame1.webp": 73291,
	"./hat1.webp": 66899,
	"./hat2.webp": 56180,
	"./hat3.webp": 42395,
	"./hat4.webp": 25258,
	"./lnybackground1.webp": 65799,
	"./lnybackground2.webp": 39166,
	"./lnybackground3.webp": 20333,
	"./lnyearring1.webp": 35596,
	"./lnyearring2.webp": 6698,
	"./lnyearring3.webp": 52943,
	"./lnyearring4.webp": 29658,
	"./lnyframe1.webp": 46014,
	"./lnyframe2.webp": 49812,
	"./lnyframe3.webp": 40869,
	"./lnyhat1.webp": 64369,
	"./lnyhat2.webp": 15691,
	"./lnyhat3.webp": 55974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79639;